"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.atob = exports.btoa = void 0;
/* eslint-disable no-restricted-globals,import/no-mutable-exports */
var buffer = typeof global !== 'undefined' && global.Buffer;
var btoa = buffer ? function (input) { return buffer.from(input, 'binary').toString('base64'); } : self.btoa.bind(self);
exports.btoa = btoa;
var atob = buffer ? function (input) { return buffer.from(input, 'base64').toString('binary'); } : self.atob.bind(self);
exports.atob = atob;
